export default __webpack_public_path__ + "static/11-86994d5923541f93dabdc826bf7da8f3.jpg";